var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-range-slider',{attrs:{"tick-size":_vm.steps.length,"min":"0","max":_vm.steps.length - 1,"value":_vm.value,"hide-details":""},on:{"input":_vm.onSliderMovementEnd}})}
var staticRenderFns = []

export { render, staticRenderFns }